export default [
  {
    title: "Manage Fop",
    icon: "CreditCardIcon",
    tagVariant: "success",
    children: [
      {
        title: "Merchant FOP",
        route: "Fops-list",
        resource: "MerchantFOP",
        action: "View",
      },
      {
        title: "All FOP",
        route: "AllFops-list",
        resource: "AllFOP",
        action: "View",
      },
      {
        title: "Providers",
        route: "Providers-list",
        resource: "Provider",
        action: "View",
      },
      {
        title: "Country-Currency",
        route: "CountryCurrency-list",
        resource: "CountryCurrency",
        action: "View",
      },
      {
        title: "Cybersource Profile",
        route: "profiles-list",
        resource: "CybersourceProfile",
        action: "View",
      },
    ],
  },
];

